import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
interface AddonsAvailableBadgeProps {
  className?: string;
}
export const AddonsAvailableBadge = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("inline-flex items-center px-2 py-0.5 text-tiny font-semibold uppercase tracking-wider", "text-accent-foreground bg-accent rounded-full flex-shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className={t1}>Add-ons available</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};